export const baseConfig = {
    cisEnabled: true,
    eventDebounce: 200,
    environment: 'browser',
    collectorPath: '/api/v1/track',
    useBeaconWhenAvailable: true,
};
